/**
 * API configuration for MathVenture
 */

export const getApiBaseUrl = () => {
  // In development, use the backend server directly
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_API_BASE || 'http://localhost:5000';
  }
  
  // In production, use same origin (Apache will proxy /api/* to Node.js backend)
  // This means API calls go to https://mathventurenp.com/api/* 
  // and Apache forwards them to http://localhost:5000/api/*
  return window.location.origin;
};

// For debugging - log the API URL being used
export const logApiConfig = () => {
  const apiUrl = getApiBaseUrl();
  console.log('🌐 Frontend URL:', window.location.origin);
  console.log('🔗 Backend API URL:', apiUrl);
  console.log('⚙️ Environment:', process.env.NODE_ENV);
  console.log('📦 API Base from ENV:', process.env.REACT_APP_API_BASE);
  
  if (process.env.NODE_ENV === 'development') {
    console.log('🚀 Development Mode: Direct backend connection');
    console.log('📡 API calls will go to:', `${apiUrl}/api/*`);
    console.log('🎯 Target: Node.js server on localhost:5000');
  } else {
    console.log('🚀 Production Mode: Using Apache reverse proxy');
    console.log('📡 API calls will go to:', `${apiUrl}/api/*`);
    console.log('🔄 Apache proxies to: http://localhost:5000/api/*');
    console.log('🌍 Production Domain: mathventurenp.com');
  }
  
  return apiUrl;
};

// Test API connectivity
export const testApiConnection = async () => {
  const apiUrl = getApiBaseUrl();
  try {
    console.log('🔍 Testing API connection to:', `${apiUrl}/api/health`);
    const response = await fetch(`${apiUrl}/api/health`);
    const data = await response.json();
    console.log('✅ API Health Check:', data);
    return { success: true, data };
  } catch (error) {
    console.error('❌ API Connection Failed:', error);
    return { success: false, error: error.message };
  }
};